import { render, staticRenderFns } from "./SiglaPatioInput.vue?vue&type=template&id=5c93331e"
import script from "./SiglaPatioInput.vue?vue&type=script&lang=js"
export * from "./SiglaPatioInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports